module.exports = __webpack_public_path__ + "static/media/main idea.551881e2.mp3";